import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { LeadUploadHistoryGrid } from '../uploadLeadsHistory/leadUploadHistoryGrid';

export const getLeadUploadRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    leadUploadHistoryGrid: {
      path: `${basePath}/lead-upload/history`,
      url: `${baseUrl}/lead-upload/history`,
      documentTitle: 'Lead Upload History',
    },
  };
};

export const getLeadUploadRoutes = (basePath: string, baseUrl: string) => {
  const config = getLeadUploadRoutesConfig(basePath, baseUrl);

  return {
    leadUploadHistoryGrid: (
      <Route exact path={config.leadUploadHistoryGrid.path}>
        <Page routeDefinition={config.leadUploadHistoryGrid}>
          <LeadUploadHistoryGrid />
        </Page>
      </Route>
    ),
  };
};
